import {Injectable, EventEmitter} from '@angular/core';

@Injectable()
export class SpinnerService {

    public isSpinnerVisible$: EventEmitter<any>;

    constructor() {
        this.isSpinnerVisible$ = new EventEmitter();
    }

    public show(): void {
        this.isSpinnerVisible$.emit(true);
    }

    public hide(): void {
        this.isSpinnerVisible$.emit(false);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/spinner.service.ts